// ** Core JWT Import
import useJwt from '@src/@core/auth/jwt/useJwt'

const serviceBaseUrl = process.env.REACT_APP_ADMIN_USER_BASE_URL ?? process.env.REACT_APP_API_BASE_URL
const servicePrefix = `${serviceBaseUrl}/svc/admin-user/api`
const { jwt } = useJwt({
  loginEndpoint: `${servicePrefix}/auth/login`,
  registerEndpoint: `${servicePrefix}/auth/login`,
  refreshEndpoint: `${servicePrefix}/auth/refresh`,
  logoutEndpoint: `${servicePrefix}/auth/logout`,

  // loginEndpoint: '/jwt/login',
  // registerEndpoint: '/jwt/register',
  // refreshEndpoint: '/jwt/refresh-token',
  // logoutEndpoint: '/jwt/logout',

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken'
})

export default jwt
